export default __webpack_public_path__ + "static/media/DIAMENT_DUZY.3f7c2f03.png";